import React from 'react';

class WordFind {
    

    constructor(){
        this.letters = 'abcdefghijklmnoprstuvwy';
        this.allOrientations = ['horizontal','horizontalBack','vertical','verticalUp',
        'diagonal','diagonalUp','diagonalBack','diagonalUpBack'];



        this.orientations = {
        horizontal:     function(x,y,i) { return {x: x+i, y: y  }; },
        horizontalBack: function(x,y,i) { return {x: x-i, y: y  }; },
        vertical:       function(x,y,i) { return {x: x,   y: y+i}; },
        verticalUp:     function(x,y,i) { return {x: x,   y: y-i}; },
        diagonal:       function(x,y,i) { return {x: x+i, y: y+i}; },
        diagonalBack:   function(x,y,i) { return {x: x-i, y: y+i}; },
        diagonalUp:     function(x,y,i) { return {x: x+i, y: y-i}; },
        diagonalUpBack: function(x,y,i) { return {x: x-i, y: y-i}; }
        };


        this.checkOrientations = {
        horizontal:     function(x,y,h,w,l) { return w >= x + l; },
        horizontalBack: function(x,y,h,w,l) { return x + 1 >= l; },
        vertical:       function(x,y,h,w,l) { return h >= y + l; },
        verticalUp:     function(x,y,h,w,l) { return y + 1 >= l; },
        diagonal:       function(x,y,h,w,l) { return (w >= x + l) && (h >= y + l); },
        diagonalBack:   function(x,y,h,w,l) { return (x + 1 >= l) && (h >= y + l); },
        diagonalUp:     function(x,y,h,w,l) { return (w >= x + l) && (y + 1 >= l); },
        diagonalUpBack: function(x,y,h,w,l) { return (x + 1 >= l) && (y + 1 >= l); }
        };
        
        this.skipOrientations = {
        horizontal:     function(x,y,l) { return {x: 0,   y: y+1  }; },
        horizontalBack: function(x,y,l) { return {x: l-1, y: y    }; },
        vertical:       function(x,y,l) { return {x: 0,   y: y+100}; },
        verticalUp:     function(x,y,l) { return {x: 0,   y: l-1  }; },
        diagonal:       function(x,y,l) { return {x: 0,   y: y+1  }; },
        diagonalBack:   function(x,y,l) { return {x: l-1, y: x>=l-1?y+1:y    }; },
        diagonalUp:     function(x,y,l) { return {x: 0,   y: y<l-1?l-1:y+1  }; },
        diagonalUpBack: function(x,y,l) { return {x: l-1, y: x>=l-1?y+1:y  }; }
        };

    }
       
    fillPuzzle = function (words, options) {
    
          var puzzle = [], i, j, len;
    
          // initialize the puzzle with blanks
          for (i = 0; i < options.height; i++) {
            puzzle.push([]);
            for (j = 0; j < options.width; j++) {
              puzzle[i].push('');
            }
          }
    
          // add each word into the puzzle one at a time
          for (i = 0, len = words.length; i < len; i++) {
            if (!this.placeWordInPuzzle(puzzle, options, words[i])) {
              // if a word didn't fit in the puzzle, give up
              return null;
            }
          }
    
          // return the puzzle
          return puzzle;
        };
    

     placeWordInPuzzle = function (puzzle, options, word) {
    
          // find all of the best locations where this word would fit
          var locations = this.findBestLocations(puzzle, options, word);
    
          if (locations.length === 0) {
            return false;
          }
    
          // select a location at random and place the word there
          var sel = locations[Math.floor(Math.random() * locations.length)];
          this.placeWord(puzzle, word, sel.x, sel.y, this.orientations[sel.orientation]);
    
          return true;
        };
    

       findBestLocations = function (puzzle, options, word) {
    
          var locations = [],
              height = options.height,
              width = options.width,
              wordLength = word.length,
              maxOverlap = 0; // we'll start looking at overlap = 0
    
          // loop through all of the possible orientations at this position
          for (var k = 0, len = options.orientations.length; k < len; k++) {
            
            var orientation = options.orientations[k],
                check = this.checkOrientations[orientation],
                next = this.orientations[orientation],
                skipTo = this.skipOrientations[orientation],
                x = 0, y = 0;
    
            // loop through every position on the board
            while( y < height ) {
    
              // see if this orientation is even possible at this location
              if (check(x, y, height, width, wordLength)) {
    
                // determine if the word fits at the current position
                var overlap = this.calcOverlap(word, puzzle, x, y, next);
    
                // if the overlap was bigger than previous overlaps that we've seen
                if (overlap >= maxOverlap || (!options.preferOverlap && overlap > -1)) {
                  maxOverlap = overlap;
                  locations.push({x: x, y: y, orientation: orientation, overlap: overlap});
                }
    
                x++;
                if (x >= width) {
                  x = 0;
                  y++;
                }
              }
              else {
                // if current cell is invalid, then skip to the next cell where
                // this orientation is possible. this greatly reduces the number
                // of checks that we have to do overall
                var nextPossible = skipTo(x,y,wordLength);
                x = nextPossible.x;
                y = nextPossible.y;
              }
    
            }
          }
    
          // finally prune down all of the possible locations we found by
          // only using the ones with the maximum overlap that we calculated
          return options.preferOverlap ?
                 this.pruneLocations(locations, maxOverlap) :
                 locations;
        };
    
        /**
        * Determines whether or not a particular word fits in a particular
        * orientation within the puzzle.
        *
        * Returns the number of letters overlapped with existing words if the word
        * fits in the specified position, -1 if the word does not fit.
        *
        * @param {String} word: The word to fit into the puzzle.
        * @param {[[String]]} puzzle: The current state of the puzzle
        * @param {int} x: The x position to check
        * @param {int} y: The y position to check
        * @param {function} fnGetSquare: Function that returns the next square
        */
        calcOverlap = function (word, puzzle, x, y, fnGetSquare) {
          var overlap = 0;
    
          // traverse the squares to determine if the word fits
          for (var i = 0, len = word.length; i < len; i++) {
    
            var next = fnGetSquare(x, y, i),
                square = puzzle[next.y][next.x];
            
            // if the puzzle square already contains the letter we
            // are looking for, then count it as an overlap square
            if (square === word[i]) {
              overlap++;
            }
            // if it contains a different letter, than our word doesn't fit
            // here, return -1
            else if (square !== '' ) {
              return -1;
            }
          }
    
          // if the entire word is overlapping, skip it to ensure words aren't
          // hidden in other words
          return overlap;
        };
    
        /**
        * If overlap maximization was indicated, this function is used to prune the
        * list of valid locations down to the ones that contain the maximum overlap
        * that was previously calculated.
        *
        * Returns the pruned set of locations.
        *
        * @param {[Location]} locations: The set of locations to prune
        * @param {int} overlap: The required level of overlap
        */
        pruneLocations = function (locations, overlap) {
    
          var pruned = [];
          for(var i = 0, len = locations.length; i < len; i++) {
            if (locations[i].overlap >= overlap) {
              pruned.push(locations[i]);
            }
          }
    
          return pruned;
        };
    
        /**
        * Places a word in the puzzle given a starting position and orientation.
        *
        * @param {[[String]]} puzzle: The current state of the puzzle
        * @param {String} word: The word to fit into the puzzle.
        * @param {int} x: The x position to check
        * @param {int} y: The y position to check
        * @param {function} fnGetSquare: Function that returns the next square
        */
        placeWord = function (puzzle, word, x, y, fnGetSquare) {
          for (var i = 0, len = word.length; i < len; i++) {
            var next = fnGetSquare(x, y, i);
            puzzle[next.y][next.x] = word[i];
          }
        };
    

          newPuzzle = function(words, settings) {
            var wordList, puzzle, attempts = 0, opts = settings || {};
    
            // copy and sort the words by length, inserting words into the puzzle
            // from longest to shortest works out the best
            wordList = words.slice(0).sort( function (a,b) {
              return (a.length < b.length) ? 1 : 0;
            });
            
            // initialize the options
            var options = {
              height:       opts.height || wordList[0].length,
              width:        opts.width || wordList[0].length,
              orientations: opts.orientations || this.allOrientations,
              fillBlanks:   opts.fillBlanks !== undefined ? opts.fillBlanks : true,
              maxAttempts:  opts.maxAttempts || 3,
              preferOverlap: opts.preferOverlap !== undefined ? opts.preferOverlap : true
            };
    
            // add the words to the puzzle
            // since puzzles are random, attempt to create a valid one up to
            // maxAttempts and then increase the puzzle size and try again
            while (!puzzle) {
              while (!puzzle && attempts++ < options.maxAttempts) {
                puzzle = this.fillPuzzle(wordList, options);
              }
    
              if (!puzzle) {
                options.height++;
                options.width++;
                attempts = 0;
              }
            }
    
            // fill in empty spaces with random letters
            if (options.fillBlanks) {
              this.fillBlanks(puzzle, options);
            }
    
            return puzzle;
          }

          fillBlanks =  function (puzzle) {
            for (var i = 0, height = puzzle.length; i < height; i++) {
              var row = puzzle[i];
              for (var j = 0, width = row.length; j < width; j++) {
    
                if (!puzzle[i][j]) {
                  var randomLetter = Math.floor(Math.random() * this.letters.length);
                  puzzle[i][j] = this.letters[randomLetter];
                }
              }
            }
          }
    

          solve = function (puzzle, words) {
            var options = {
                            height:       puzzle.length,
                            width:        puzzle[0].length,
                            orientations: this.allOrientations,
                            preferOverlap: true
                          },
                found = [],
                notFound = [];
    
            for(var i = 0, len = words.length; i < len; i++) {
              var word = words[i],
                  locations = this.findBestLocations(puzzle, options, word);
    
              if (locations.length > 0 && locations[0].overlap === word.length) {
                locations[0].word = word;
                found.push(locations[0]);
              }
              else {
                notFound.push(word);
              }
            }
    
            return { found: found, notFound: notFound };
          }

      };

      export default WordFind;